export default {
  notaAlumnoCursado: {},
  notaAlumnoCursados: [],
  errorArray: [],
  fields: {},
  record: {
    nuevo: false,
    actualizado: false,
  },
  pagination: {},
};
